import { CardHolderSate } from '../../../../UserInputFields/CardHolderInput/CardHolderInput';
import { CreditCardState } from '../../../../UserInputFields/CreditCardInput/CreditCardInput';

export function getConektaToken({
  creditCard,
  cardHolder,
}: {
  creditCard: CreditCardState;
  cardHolder: CardHolderSate;
}) {
  return new Promise<{ token: string }>((resolve, _) => {
    window.Conekta.setPublicKey(window.CONEKTA_PUBLIC_KEY);
    const dateString = creditCard.expiration.split('/');

    const expMonth = dateString[0];
    const expYear = dateString[1];

    const card = {
      number: creditCard.number,
      name: cardHolder,
      exp_month: expMonth,
      exp_year: `20${expYear}`,
      cvc: creditCard.cvc,
    };

    window.Conekta.Token.create({ card }, (token: { id: string }) =>
      resolve({ token: token.id }),
    );
  });
}
